import { Component, inject } from '@angular/core';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import moment from 'moment';

import { GridOptionsService } from '../../../columns/column-definition/grid-options.service';
import { OrdersApiClientService } from '../../../services/orders.api.client.service';
export const MY_FORMATS = {
  parse: {
    dateInput: 'DD MMM YYYY',
  },
  display: {
    dateInput: 'DD MMM YYYY',
    monthYearLabel: 'MMM YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-cancel-order-dialog',
  templateUrl: './cancel-order-dialog.component.html',
  styleUrls: ['./cancel-order-dialog.component.scss'],
  providers: [{ provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }],
  standalone: false,
})
export class CancelOrderDialogComponent {
  data = inject(MAT_DIALOG_DATA);
  private ordersService = inject(OrdersApiClientService);
  private gridOptionService = inject(GridOptionsService);
  dialogRef = inject<MatDialogRef<CancelOrderDialogComponent>>(MatDialogRef);

  public selectedDate: any;
  minDate: Date;

  constructor() {
    this.minDate = new Date();
    this.selectedDate = moment().add(1, 'day');
  }

  cancelOrder(): any {
    const utcDateTime = this.selectedDate.utc(true).toDate().getTime() / 1000;
    const cancelOrderRequest = this.ordersService.cancelOrder(
      utcDateTime,
      this.data.orderId,
    );

    if (
      !cancelOrderRequest ||
      typeof cancelOrderRequest.subscribe !== 'function'
    ) {
      this.dialogRef.close();
      return;
    }

    cancelOrderRequest
      .subscribe(() => {
        this.gridOptionService.refreshData(
          this.selectedDate.format('DD MMM YYYY'),
          'cancelDate',
          this.data.orderId,
        );
      })
      .add(() => this.dialogRef.close());
  }
}
